/// <reference path="../../../app.definition.ts" />

import angular from 'angular';

function autoResize($timeout): ng.IDirective {
    return {
        restrict: 'A',
        require: '?ngModel',
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs, ngModel: ng.INgModelController): void => {
            if (!ngModel) return;

            const resize = () => {
                element.height(0).height(element[0].scrollHeight + 1);
            }

            element.css({ 'padding': '0px', 'max-height': '100px' })
            element.on('load change keyup keydown paste cut', function () {
                resize();
            });
            
            /* There are cases where the textarea is disabled and the content is updated programmatically, in such cases we need to resize the textarea to fit the new content.*/
            if (
                !!attrs.ngDisabled
            ) {
                let isInitialRender = true;
                ngModel.$render = () => {
                    const newValue = ngModel.$viewValue || '';
                    element.val(newValue);

                    // To avoid resizing on the initial render because it is handled in the $timeout below
                    if (isInitialRender) {
                        isInitialRender = false;
                        return;
                    }

                    resize();
                };
            }
            $timeout(function () {
                const value = element.val();
                /*  Since the height of textarea needs to be set on the load to avoid 
                    change of height while adding the text, we are setting the number of rows 
                    and not height to avoid the conversion of blank fields to empty string. 
                    This is needed while comparing the models while submitting the forms.
                */
                element[0]['rows'] = 1;
                if (value) {
                    element.change();
                    $timeout(function () {
                        element.val(value);
                    }, 20);
                }
            }, 10);
        }
    };
}

angular.module('eCareVault.common.directives').directive('autoResize', ['$timeout', autoResize]);
